import React from 'react';
import { outlineTexts } from '../contexts/LangHO';
import outgroupImg from '../assets/images/halcyon/outgroup.png';
import outbusinessImg from '../assets/images/halcyon/outbusiness.png';
import dataencryptionImg from '../assets/images/halcyon/dataencryption.png';


function ProductHOOutline({ lang = 'ko', isMobile = false }) {
  return (
    <div
      style={{
        width: '100vw',
        maxWidth: '100vw',
        background: 'rgba(0, 66, 116, 0.5)',
        borderRadius: 12,
        boxShadow: '0 2px 12px rgba(0,0,0,0.10)',
        padding: isMobile ? '0 10px' : '0',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start'
      }}
    >
      <span style={{
        fontSize: isMobile ? '1.7rem' : '2rem',
        fontWeight: 700,
        color: '#fff',
        marginBottom: isMobile ? 12 : 16,
        paddingLeft: isMobile ? 20 : 40,
        paddingTop: isMobile ? 20 : 28,
        display: 'block',
        lineHeight: 1.3,
        textAlign: 'center',
        width: '100%'
      }}>
        <br/>{outlineTexts.title[lang]}
      </span>
      <div
        className="outline-flex"
        style={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          width: '100%',
          padding: isMobile ? '16px 20px 24px 20px' : '24px 40px 32px 40px',
          boxSizing: 'border-box',
          gap: isMobile ? 20 : 32
        }}
      >
        {outGroupBox({ lang, isMobile })}
        {outBusinessBox({ lang, isMobile })}
        {outDuressBox({ lang, isMobile })}
      </div>
      {/* 반응형 처리: 화면이 작아질 때 동영상이 아래로 내려오도록 */}
      <style>
        {`
          @media (max-width: 900px) {
            .outline-flex {
              flex-direction: column !important;
              gap: 24px !important;
            }
            .outline-flex .ho-box {
              width: 100% !important;
            }
          }
        `}
      </style>
    </div>
  );
}


// 1번 박스 함수: 조직 보안 격차
function outGroupBox({ lang, isMobile = false }) {
  return (
    <div
      className="ho-box"
      style={{
        flex: isMobile ? '1 1 100%' : '1 1 300px',
        minWidth: isMobile ? 'auto' : 260,
        width: isMobile ? '100%' : 'auto',
        background: '#04406B',
        borderRadius: 16,
        padding: isMobile ? '24px 20px' : '32px 28px',
        color: '#fff',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0 4px 18px rgba(0,0,0,0.25)',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      <img
        src={outgroupImg}
        alt={outlineTexts.group.title[lang]}
        style={{
          maxWidth: isMobile ? '60%' : '70%',
          height: 'auto',
          objectFit: 'contain',
          alignSelf: 'center',
          marginBottom: isMobile ? 10 : 12,
          display: 'block'
        }}
      />
      <h3 style={{ 
        margin: 0, 
        fontSize: isMobile ? '1.1rem' : '1.25rem', 
        fontWeight: 700 
      }}>
        {outlineTexts.group.title[lang]}
      </h3>
      <p style={{ 
        margin: isMobile ? '12px 0 0 0' : '14px 0 0 0', 
        lineHeight: 1.55, 
        fontSize: isMobile ? '0.85rem' : '0.95rem', 
        fontWeight: 400 
      }}>
        {outlineTexts.group.message[lang]}
      </p>
    </div>
  );
}

// 2번 박스 함수: 랜섬웨어 비즈니스
function outBusinessBox({ lang, isMobile = false }) {
  return (
    <div
      className="ho-box"
      style={{
        flex: isMobile ? '1 1 100%' : '1 1 300px',
        minWidth: isMobile ? 'auto' : 260,
        width: isMobile ? '100%' : 'auto',
        background: '#04406B',
        borderRadius: 16,
        padding: isMobile ? '24px 20px' : '32px 28px',
        color: '#fff',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0 4px 18px rgba(0,0,0,0.25)',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      <img
        src={outbusinessImg}
        alt={outlineTexts.business.title[lang]}
        style={{
          maxWidth: isMobile ? '60%' : '70%',
          height: 'auto',
          objectFit: 'contain',
          alignSelf: 'center',
          marginBottom: isMobile ? 10 : 12,
          display: 'block'
        }}
      />
      <h3 style={{ 
        margin: 0, 
        fontSize: isMobile ? '1.1rem' : '1.25rem', 
        fontWeight: 700 
      }}>
        {outlineTexts.business.title[lang]}
      </h3>
      <p style={{ 
        margin: isMobile ? '12px 0 0 0' : '14px 0 0 0', 
        lineHeight: 1.55, 
        fontSize: isMobile ? '0.85rem' : '0.95rem', 
        fontWeight: 400 
      }}>
        {outlineTexts.business.message[lang]}
      </p>
    </div>
  );
}

// 3번 박스 함수: 이중 협박(듀레스) 위험
function outDuressBox({ lang, isMobile = false }) {
  return (
    <div
      className="ho-box"
      style={{
        flex: isMobile ? '1 1 100%' : '1 1 300px',
        minWidth: isMobile ? 'auto' : 260,
        width: isMobile ? '100%' : 'auto',
        background: '#04406B',
        borderRadius: 16,
        padding: isMobile ? '24px 20px' : '32px 28px',
        color: '#fff',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0 4px 18px rgba(0,0,0,0.25)',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      <img
        src={dataencryptionImg}
        alt={outlineTexts.duress.title[lang]}
        style={{
          maxWidth: isMobile ? '60%' : '70%',
          height: 'auto',
          objectFit: 'contain',
          alignSelf: 'center',
          marginBottom: isMobile ? 10 : 12,
          display: 'block'
        }}
      />
      <h3 style={{ 
        margin: 0, 
        fontSize: isMobile ? '1.1rem' : '1.25rem', 
        fontWeight: 700 
      }}>
        {outlineTexts.duress.title[lang]}
      </h3>
      <p style={{ 
        margin: isMobile ? '12px 0 0 0' : '14px 0 0 0', 
        lineHeight: 1.55, 
        fontSize: isMobile ? '0.85rem' : '0.95rem', 
        fontWeight: 400 
      }}>
        {outlineTexts.duress.message[lang]}
      </p>
    </div>
  );
}




export default ProductHOOutline;